export const GET_ADMIN_BY_ID = 'admin/GET_ADMIN_BY_ID';
export const UPDATE_ADMIN_BY_ID = 'admin/UPDATE_ADMIN_BY_ID';
